export const HTTP_STATUS_CODE = {
  CONTINUE: 100,
  SWITCHING_PROTOCOLS: 101,
  PROCESSING: 102,
  HEURISTIC_EXPIRATION: 113,
  MISCELLANEOUS_WARNING: 199,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  MULTI_STATUS: 207,
  ALREADY_REPORTED: 208,
  TRANSFORMATION_APPLIED: 214,
  IM_USED: 226,
  MISCELLANEOUS_PERSISTENT_WARNING: 299,
  MULTIPLE_CHOICES: 300,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  USE_PROXY: 305,
  UNUSED: 306,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  TOO_MANY_REDIRECTS: 310,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  IM_A_TEAPOT: 418,
  MISDIRECT_REQUEST: 421,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  UNORDERED_COLLECTION: 425,
  UPGRADE_REQUIRED: 426,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUEST: 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  VARIANT_ALSO_NEGOTIATES: 506,
  INSUFFICIENT_STORAGE: 507,
  LOOP_DETECTED: 508,
  NOT_EXTENDED: 510,
  NETWORK_AUTHENTICATION_REQUIRED: 511,
  SUCCESS: 'SUCCESS',
};
export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
export const HEADER_PARAM = {
  CLIENT_MESSAGE_ID: 'clientMessageId',
  TRANSACTION_TIME: 'transactionTime',
};
export const SYSTEM_FORMAT_DATA = {
  DATE_FORMAT: 'dd/MM/yyyy',
  DATE_TIME_FORMAT: 'dd/MM/yyyy HH:mm:ss',
  MONTH_TIME_FORMAT: 'MM/yyyy',
  YEAR_TIME_FORMAT: 'yyyy',
  DATE_FORMAT_MILLISECONDS: 'yyyyMMddHHmmssSSS',
  EMAIL_FORMAT: '[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+',
  PHONE_FORMAT: '^[ ]*((\\84)|0)([0-9]{9,10})[ ]*',
  FLOAT_FORMAT: '[^.]*([.](.{1,2}))?',
  NUMBER_FORMAT: '[^.]+',
};
export const STORAGE_NAME = {
  USER_LOGIN: 'USER_LOGIN',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  NUMBER_LOGIN_FAILED: 'NUMBER_LOGIN_FAILED',
  PKCE_CODE_VERIFIER: 'PKCE_CODE_VERIFIER',
  EXPIRES_AT: 'EXPIRES_AT',
  ID_TOKEN: 'ID_TOKEN'
};
export const MICRO_SERVICE = {
  DEFAULT: 'DEFAULT',
  ADMIN: 'ADMIN',
  LIBRARY: 'LIBRARY',
  HRM: 'HRM',
  ONBOARDING: 'ONBOARDING',
  ABS_MANAGEMENT: 'ABS_MANAGEMENT',
  KPI: 'KPI',
  ABS: 'ABS',
  CRM: 'CRM',
  LMS: 'LMS',
  MAT: 'MAT',
  ICN: 'ICN',
  PIT: 'PIT',
  PTX: 'PTX',
  SSO: 'SSO',
  EXAM: 'EXAM'
};
